// @flow
import React from 'react';

import ErrorReporter from 'app/components/ErrorReporter';
import IndividualRecipientItem from './IndividualRecipientItem';
import GroupRecipientItem from './GroupRecipientItem';
import OrganizationRecipientItem from './OrganizationRecipientItem';
import GroupChatRecipientItem from './GroupChatRecipientItem';
import type { ComposerRecipients_composerRecipients_recipients } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients,
  recipientIsSelected: boolean,
  districtIsSelected: boolean,
  nonDistrictRecipientIsSelected?: boolean,
  selectionLength: number,
};

export default class RecipientItem extends React.Component<Props, *> {
  render() {
    const { entity, recipientIsSelected } = this.props;

    if (entity.__typename === 'TextHeader') {
      return null;
    }

    if (entity.recipient.type === 'individual') {
      return <IndividualRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} />;
    } else if (entity.recipient.type === 'group') {
      return <GroupRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} />;
    } else if (entity.recipient.type === 'district') {
      return (
        <OrganizationRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} />
      );
    } else if (entity.recipient.type === 'group_chat') {
      return <GroupChatRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} />;
    }

    return <ErrorReporter error="empty content in RecipientItem" />;
  }
}
